import { map } from 'lodash';

import {
  getConnectionParams,
  isSpatial,
  getGeoJSONProps,
  getThematicKeyList
} from '../api/Layers/layer-operations';

import methodPromise from './method-promise-wrapper';

/**
 * Fetches the PostgreSQL and returns the two arrays needed for the table.
 *
 * @async
 * @param {string} layer - The PostgreSQL layer.
 * @returns {object} An object containing the two arrays needed for the table.
 * @throws {Error} If something goes wrong.
 */
const loadPostgreSQLTable = async layer => {
  try {
    const loadParameters = getConnectionParams(layer);
    const attributes = isSpatial(layer)
      ? map(getGeoJSONProps(layer), 'name')
      : getThematicKeyList(layer);
    const table = await methodPromise('layers.loadPostgreSQL', {
      loadParameters,
      attributes,
      isThematic: true
    });
    const [tableTitle, ...tableBody] = table;
    return { tableBody, tableTitle };
  } catch (err) {
    throw new Error(err.message);
  }
};

export default loadPostgreSQLTable;
